import TableCellRenderer from "../../../table/TableCellRenderer";
import {cancelBubble} from "../../../atBrowserUtils"

export default class RemoveRowCellRenderer extends TableCellRenderer {

    constructor() {
        super()
    }

    init() {
        return this;
    }

    generateContent(cell) {
        const removeBtn = document.createElement("a");
        removeBtn.innerHTML = "&nbsp;";
        const self = this;
        removeBtn.onclick = function(e) {
            cancelBubble(e);
            self.onRemoveClick(cell);
        };
        cell.getCellEl().appendChild(removeBtn);
    }

    getCellClassName() {
        return ["removeBtn"];
    }

    onRemoveClick(cell) {
        cell.getTable().toggleRemove(cell.getRow().getRowIdx());
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/RemoveRowCellRenderer.js